export default __webpack_public_path__ + "static/media/chain.1768281e.svg";